import { baseSeriesMark } from "../base/constant";

export const boxPlotSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    boxPlot: {
        name: "boxPlot",
        type: "boxPlot"
    },
    outlier: {
        name: "outlier",
        type: "symbol"
    }
});
//# sourceMappingURL=constant.js.map
